module.exports = __webpack_public_path__ + "static/media/Carson-Erard.96459bff.png";